import { RoutePaths, type RoutePathItem } from "~/common/constants/route-paths";
import { UrlParamsKeys } from "~/common/constants/url-params-keys";

const validRedirectPaths = new Set<string>(Object.values(RoutePaths));

/**
 *  Get the page to redirect to after authentication
 *  If the redirect path is not valid, redirect to the applications page
 */
export const getAfterAuthPageRedirect = (): RoutePathItem => {
  const urlParams = new URLSearchParams(window.location.search);
  const redirectTo = urlParams.get(UrlParamsKeys.REDIRECT_TO);

  if (redirectTo && validRedirectPaths.has(redirectTo)) {
    return redirectTo as RoutePathItem;
  }

  return RoutePaths.APPLICATIONS;
};
